import React, { Component } from 'react'
import Input from '../../input'
import JewelryPanel from '../jewelry-panel'
import SelectItem from '../../select-item'
import { Grid, GridItem } from '../../grid'
import Spacer from '../../spacer'
import {
  showStockItemPanel
} from '../../../utils/jewelry-validation'

class StockItemPanel extends Component {
  render () {
    const props = this.props
    const getItemPriceCurrency = () => {
      return [
        {value: 'usd', label: 'USD'},
        {value: 'cad', label: 'CAD', disabled: props.sessionCurrency === 'usd'}
      ]
    }
    return (
      <JewelryPanel
        id='stockItemContainer'
        show={showStockItemPanel(props)}
        isResetting={props.isResetting}>

        <Spacer lg />

        <h4 id='stock_item_description'>Item Description</h4>
        <Input
          inputId='item_description'
          value={props.item_description}
          onChange={props.onChangeVal.bind(this, 'item_description')}
          initVal={''}
        />

        <Spacer xxs />

        <h4>Item Price</h4>
        <Grid>
          <GridItem col='7/8'>
            <Input
              inputId='item_price'
              type='number'
              step={0.01}
              value={props.item_price}
              placeholder='$'
              onChange={props.onChangeVal.bind(this, 'item_price')}
              initVal={''}
            />
          </GridItem>
          <GridItem col='1/8'>
            <SelectItem
              id='item_price_currency'
              label=''
              labelId='itemPriceCurrency'
              options={getItemPriceCurrency()}
              value={props.item_price_currency}
              onChange={props.onChangeVal.bind(this, 'item_price_currency')}
              initVal={null}
            />
          </GridItem>
        </Grid>

        <Spacer xxs />

        <h4>Number of Primary Diamonds Outstanding</h4>
        <Input
          inputId='primary_diamond_qty'
          type='number'
          step={1}
          value={props.primary_diamond_qty}
          onChange={props.onChangeVal.bind(this, 'primary_diamond_qty')}
          initVal={0}
        />

      </JewelryPanel>
    )
  }
}

export default StockItemPanel



// WEBPACK FOOTER //
// ./src/components/jewelry-search-filters/stock-item-panel/index.js